import { isDefined } from '@pai/commons'

export function hasPropsDefined<T, K extends keyof T>(
  obj: T,
  props: K[],
): obj is T & { [key in K]-?: NonNullable<T[key]> } {
  return props.every((prop) => isDefined(obj[prop]))
}
